/* unplugin-vue-components disabled */import { render } from "./PageFooter.vue?vue&type=template&id=1e61daf0&scoped=true&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=1e61daf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e61daf0"]])

export default __exports__